import React, { useState, useEffect } from 'react';
import { splitEvery } from 'ramda';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import LoadingOverlay from 'components/LoadingOverlay';
import {
  ERROR_MESSAGE_DEFAULT,
  ERROR_TITLE_DEFAULT
} from 'products/nomad_insurance/constants';
import Member from '../Member';
import Pagination from '../Pagination';
import { MembersContainer, StyledAlert } from './styled';

const ROW_HEIGHT = 122;

const getNumberOfRows = (windowHeight) => {
  if (windowHeight > 800) return 5;
  if (windowHeight > 680) return 4;
  return 3;
};

const getMembersPerRow = (windowWidth) => {
  if (windowWidth < 800) return 1;
  if (windowWidth < 1300) return 2;
  return 3;
};

const MembersGrid = ({ teamMembers, onMemberSelect, isLoading, error }) => {
  const { height: windowHeight, width: windowWidth } = useWindowSize();
  const [currentPage, setCurrentPage] = useState(1);

  const numberOfRows = getNumberOfRows(windowHeight);
  const membersPerRow = getMembersPerRow(windowWidth);
  const membersPerPage = numberOfRows * membersPerRow;
  const paginatedTeamMembers = splitEvery(membersPerPage, teamMembers);
  const numberOfPages = paginatedTeamMembers.length;

  const gridHeight = ROW_HEIGHT * numberOfRows;

  useEffect(() => {
    setCurrentPage(1);
  }, [teamMembers]);

  const onNext = () => {
    if (currentPage < numberOfPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const onPrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <MembersContainer style={{ height: `${gridHeight}px` }}>
        <LoadingOverlay isLoading={isLoading && !error} />

        {error && !isLoading && (
          <StyledAlert variant="danger" label={ERROR_TITLE_DEFAULT}>
            {ERROR_MESSAGE_DEFAULT}
          </StyledAlert>
        )}

        {!isLoading &&
          !error &&
          paginatedTeamMembers?.[currentPage - 1]?.map((member) => (
            <Member
              key={member.id}
              firstName={member.firstName}
              lastName={member.lastName}
              role={member.role}
              country={member.country}
              photo={member.photo}
              bird={member.bird}
              onClick={() => onMemberSelect(member)}
            />
          ))}
      </MembersContainer>

      {!isLoading && !error && numberOfPages > 1 && (
        <Pagination
          onNext={onNext}
          onPrev={onPrev}
          currentPage={currentPage}
          numberOfPages={numberOfPages}
        />
      )}
    </>
  );
};

MembersGrid.propTypes = {
  teamMembers: PropTypes.array.isRequired,
  onMemberSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool
};

export default MembersGrid;
